module.exports = __webpack_public_path__ + "static/img/chejia_2.7cd1169.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Homepage/chejia_2.png
// module id = bbip
// module chunks = 19